import React from "react";
import style from "../assets/styles/style.module.scss";
import classes from "./About.module.scss";
import "../assets/styles/icomoon.css";
import {Slide} from "react-awesome-reveal";

function About() {
    return (<div className={style.section}>
            <div className={style.container}>
                <div className={style.row}>
                    <div className={`${classes.img} col-md-5`}/>
                    <div className={`${classes.description} col-md-5 p-md-5`}>
                        <div className={classes.heading}>
                            <span className={classes.subheading}>Welcome to Casa Kotys</span>
                            <h2 className={classes.title}>Welcome To Our Lodging</h2>
                        </div>
                        <div className={classes.body}>
                            <p>Casa Kotys is located in Albești - Pănâteni village, in the middle of nature, but also close to the
                                main road, Transfăgărășan, leading to Curtea de Argeș (8km) or to the Făgăraş Mountains with Vidraru
                                Lake (53 km) and Bâlea Lake (77 km). The recently built and the furnished house offers double,
                                triple or quadruple rooms with own bathroom and windows facing the garden or the small forest
                                nearby.</p>
                            <p>Casa Kotys disposes of a big kitchen equipped with fridge and stove, a living room and a big
                                garden.</p>
                            <ul className={classes.social}>
                                <Slide triggerOnce direction="up">
                                    <li><a target="_top" href="https://www.facebook.com/Casa-Kotys-346772686015841">
                                        <span className="icon-facebook"/></a></li>
                                </Slide>
                                <Slide triggerOnce direction="up">
                                    <li><a target="_top" href="https://www.instagram.com/casakotys/"><span className="icon-instagram"/></a>
                                    </li>
                                </Slide>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
}

export default About;
